/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * AssignmentProgressCardContainer
 *
 * @file AssignmentProgressCardContainer.jsx
 * @author Gladson Samuel S
 * @since 1.0.0
 */


import React from 'react';
import { IntlProvider } from 'react-intl';
import PropTypes from 'prop-types';
import { InternationalSupport } from '@aquila/core';
import ErrorBoundary from '../components/common/ErrorBoundary';
import msgObject from '../../translations';
import AssignmentProgressCard from '../components/assignmentProgressCard/AssignmentProgressCard';

const AssignmentProgressCardContainer = (props) => {
  const intlObj = new InternationalSupport(msgObject, props.locale);

  return (
    <IntlProvider locale={intlObj.getLocale()} messages={intlObj.getMessages()}>
      <ErrorBoundary>
        <AssignmentProgressCard {...props} />
      </ErrorBoundary>
    </IntlProvider>
  );
};

AssignmentProgressCardContainer.propTypes = {
  locale: PropTypes.string
};

AssignmentProgressCardContainer.defaultProps = {
  locale: 'en'
};

export default AssignmentProgressCardContainer;

